import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, TESTIDS } from "@/lib/site";
import SEO from "@/components/SEO";

export default function FAQ() {
  return (
    <div>
      <SEO
        title="FAQ"
        path="/faq"
        description="Common questions about Fascial Stretch Therapy, personal training, and mobility coaching with BW MATRIX in Mississauga / GTA."
      />
      <section className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16 md:pb-24">
          <p className="label-eyebrow mb-6">FAQ</p>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-display uppercase font-bold text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight text-white max-w-4xl"
          >
            Common<br />
            <span className="text-white/50">questions.</span>
          </motion.h1>
        </div>
      </section>

      <section>
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {FAQS.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                data-testid={TESTIDS.faq.item(idx)}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="py-6 text-left font-display uppercase text-lg md:text-2xl font-bold tracking-tight text-white hover:text-white hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-zinc-300 text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-16 border border-white/10 bg-[#141417] p-8 md:p-10">
            <p className="label-eyebrow mb-3">Still curious?</p>
            <h3 className="font-display uppercase text-3xl font-bold text-white leading-tight tracking-tight">
              Ask directly.
            </h3>
            <p className="mt-3 text-zinc-400">Reach out — happy to answer anything specific to your body or goals.</p>
            <Link
              to="/book"
              data-testid="faq-cta-button"
              className="mt-8 inline-flex items-center gap-3 bg-white text-black px-6 py-3 text-xs uppercase tracking-[0.25em] font-bold hover:bg-zinc-200 transition-colors group"
            >
              Contact me
              <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
